export const EDIT_ORDER_LOADING_HISTORY_CATALOG =
  'Carregando informações dos produtos…'

const EDIT_ORDER = {
  title: 'Edição de pedidos',
  close: 'Fechar',
  confirm: 'Confirmar',
  goToSummaryButton: 'Ir para o resumo',
  summaryConfirm: 'Confirmar Edição',
  back: 'Voltar',
  contentTitle: 'Diminua ou zere as quantidades para editar',
  ongoing: 'Substitua ou exclua as quantidades editadas',
  deleted: 'Excluídos',
  deleteButton: 'EXCLUIR',
  deleteButton2: 'Excluir',
  replaceButton: 'SUBSTITUIR',
  replaceButton2: 'Substituir',
  noChanges: 'Nenhuma edição feita até o momento',
  undoButton: 'Desfazer',
  zeroQuantity: 'Zerar a quantidade',
  quantityLabel: 'QTD: ',
  alreadyReviewChanges: 'Você já revisou as edições',
  price: 'R$',
  selectReplacedProduct: 'Selecione o produto substituto',
  productSearch: 'Busca de produtos',
  categoryPlaceholder: 'Categorias',
  availability: 'Disponibilidade',
  othersFilter: 'Outros',
  productNotFoundAltImg: 'Produto não encontrado',
  doFilter: 'Filtrar',
  resetFilters: 'Limpar Filtros',
  clearFilterButton: 'Clear Filter Button',
  filterBar: 'Filter Bar',
  replacements: 'Substituídos',
  backButton: 'Voltar',
  confirmButton: 'Confirmar',
  continueButton: 'Continuar',
  CATEGORIES: 'CATEGORIES',
  beers: 'Cervejas',
  productNotFoundSearch: 'Ops, nenhum resultado encontrado para',
  searchForSameCategory:
    'Busque um produto da mesma categoria do produto inicial',
  productNotFound: 'Ops, nenhum resultado encontrado',
  seeMoreProducts: 'Ver mais produtos',
  summaryTitle: 'Resumo da edição',
  unavailableProductInHistory: 'Produto indisponível',
  historyCatalogError:
    'Não foi possível carregar os dados de alguns produtos. Tente novamente.',
  historyCatalogRetryButton: 'Tentar novamente',
  deletion: 'Exclusão',
  replace: 'Substituição',
  initialBag: 'Sacola inicial',
  currentBag: 'Sacola atual',
  finalBag: 'Sacola final',
  totalLabel: 'TOTAL DOS PRODUTOS',
  printNewOrderOnConfirm: 'Imprimir nova nota ao confirmar',
  defaultRequestError: 'Houve um erro, tente novamente mais tarde',
  editOrderError:
    'Não foi possível editar o pedido, tente novamente mais tarde',
  listItemsQueryError:
    'Não foi possível retornar a lista de produtos disponíveis. Tente novamente mais tarde',
  youWillReplace: 'Você irá substituir',
  unavailableForSubstitutionInOrder:
    'Indisponível para substituição neste pedido',
  limitedPromoBadge: 'Promo Ltda',
  limitedPromoTooltip:
    'A promoção foi aplicada apenas nestas unidades. Por isso o produto aparece separado em dois.',
  cantDeleteItem: 'Você não pode excluir todos os itens do carrinho',
  cantReplaceItem:
    'Cliente pede para excluir item em caso de indisponibilidade',
  success: 'Pedido editado com sucesso',
  editLimit: {
    title: 'Limite de edição excedido ➜',
    deleteMessage: 'Substitua por outro item ou exclua menos itens',
    replacementMessage: '%s a quantidade do produto substituto',
    increase: 'Aumente',
    reduce: 'Diminua',
    minimum: 'Essa edição reduziria o pedido para %val (mínimo: %limit)',
    maximum: 'Essa edição aumentaria o pedido para %val (máximo: %limit)',
  },
  analytics: {
    revertToOriginalOrderModalViewed: 'Reverter ao pedido inicial',
    modalName: 'Order Edit Modal',
    modalNameReplacement: 'Edit Replacement Modal',
    orderAlreadyEditedModal: 'Order Already Edited Modal',
    orderUndoEditModal: 'Order Undo Edit Modal',
    button: 'button',
    returnButton: 'Return Edit Button',
    continueButton: 'Confirm Replacement Button',
    edit: 'Editar',
    revertAndEdit: 'Reverter ao original e editar novamente',
    revertButton: 'Reverter',
    closeButton: 'Fechar',
    noButton: 'Não',
    resetQuanitity: 'Reset Quantity Button',
    closeModal: 'Close Button',
    goToSummary: 'Go To Summary Button',
    replaceProductButton: 'Replace Product Button',
    deleteProductButton: 'Delete Product Button',
    undoEditButton: 'Undo Edit Button',
    confirmEditButton: 'Confirm Edit Button',
    editSummaryModal: 'Edit Summary Modal',
    replacementProduct: 'Replace Product Button',
    clickReplacementProduct: 'Replacement Product Selection Card',
    filterTypes: {
      search: 'SEARCH',
      categories: 'CATEGORIES',
    },
    macroJourney: 'orders',
    microJourney: 'edit',
    customerPreference: {
      replaceItem: 'Substituir item',
      removeItem: 'Remover item',
    },
    contactClientComponent: 'Falar com cliente',
    openWhatsappComponent: 'Abrir Whatsapp',
    closeWhatsappAlertComponent: 'Fechar alerta whatsapp',
    iconButton: 'icon button',
    undoOngoingEditComponent: 'Desfazer antes de optar pela edicao',
    textButton: 'text button',
    editHistoryOrderButton: 'Edit History Order Button',
    editHistoryModalViewed: 'Edit History Modal',
    editValueLimitType: {
      minimum: 'limite minimo',
      maximum: 'Limite maximo',
    },
  },
  customerPreferenceSection: {
    withOrientationTitle: '%NAME DEIXOU UMA ORIENTAÇÃO',
    withoutOrientationTitle: '%NAME NÃO DEIXOU UMA ORIENTAÇÃO',
    customerRoleLabel: '%NAME • CLIENTE',
    callButton: 'Ligar para o cliente',
    whatsappButton: 'Chamar no Whatsapp',
    whatsappButtonCompact: 'Whatsapp',
    nameFallbackForCta: 'cliente',
    nameFallbackSection: 'CLIENTE',
  },
  alert: {
    text: 'Entre em contato antes da edição',
    contactClient: 'Falar com cliente',
    whatsappButton: 'Abrir WhatsApp',
    consumerTelephone: 'Telefone do cliente:',
    whatsappMessage: `Oi! Aqui é a loja %STORE_NAME, parceira do Zé Delivery.\n
Estamos com um problema de estoque de um ou mais itens do seu pedido %ORDER_NUMBER.\n
Você pode nos ajudar decidindo como deseja prosseguir?`,
    error: 'Não foi possível buscar o telefone. Tente novamente mais tarde.',
    clientPreference: 'Cliente prefere: ',
    replace: 'Trocar por um similar',
    delete: 'Excluir o que falta',
    orientationMessage: 'Oi! Se faltar algum item, ',
  },
  onlinePaymentAlert: {
    message:
      'Pedido com pagamento online: não é possível aumentar o valor inicial',
    reverseBill:
      'Pagamento online: a diferença será estornada automaticamente ao cliente após a entrega.',
    maximum: '(máximo: %val)',
    subtotalIncreaseLine: 'Valor adicional sobre o pedido: %s',
  },
  codeChangeAlert: {
    message:
      'Ao confirmar, uma nova nota será gerada com um novo QR Code. Imprima!',
  },
  updateStockoutProducts: {
    successToast: 'Produto(s) editado(s) desativado(s) do seu estoque',
    successToastSingular: 'Produto editado desativado do seu estoque',
  },
  revertToInitialOrderButton: 'Reverter ao pedido inicial',
  loadingHistoryCatalog: EDIT_ORDER_LOADING_HISTORY_CATALOG,
  fakeDoor: {
    checkBoxTextPending:
      'Quero arcar com a diferença desta substituição e não cobrar do cliente',
    checkBoxTextTemplate:
      'Quero pagar a diferença de %s da substituição e não cobrar do cliente',
    feedBackText1:
      'Funcionalidade em teste: em breve você poderá pagar a diferença.',
    feedBackText2: 'Diminua a quantidade ou selecione outro produto',
    tooltipText:
      'Ao selecionar essa opção, o valor da diferença não será cobrada do cliente ou restituído a você ',
  },
  practiceOrder: {
    title: 'Aprenda a editar · pedido teste',
    testOrder: 'Pedido de teste',
    numberAbbreviation: 'Nº',
  },
}

export default EDIT_ORDER
